// TAT rules from NABL_Discussion.docx
// Escalation (applies to all activities): JD +1, Director +2 more, CEO +2 more
export const ESCALATION = { jd: 1, director: 3, ceo: 5 }; // cumulative from DO days

const isSubsequent = (desc) => /subsequent|resubmit|iteration/i.test(desc);

// Returns DO-allowed days for the current stage based on Stage/Description + AssessmentType
// Stage field may contain the full description text (API returns description in Stage column)
export const getDODays = (row) => {
    const desc = (row.Stage || row.Description || '').toLowerCase();
    const name = (row.AssessmentType || '').toLowerCase();

    // Approval Process — forwarded to Director/CEO/JD for approval: 2 days
    if (/forward.*director|forward.*ceo|forward.*approval|approv.*certificate|certificate.*approv/i.test(desc)) return 2;

    // Assessment Planning / Schedule
    if (/assessment.*plan|plan.*assessment|assessment.*schedul|schedul.*assessment/i.test(desc)) return 5;

    // Assessment Completed / Submitted to NABL or JD → Review of Assessment Report: 2 days
    if (/assessment.*complet|assessment.*submit|submitted.*nabl|submitted.*jd/i.test(desc)) return 2;

    // Assessment Report Review
    if (/assessment.*report|report.*review/i.test(desc)) return 2;

    // NC Closure / Form 11
    if (/\bnc\b|non.?conform|form.?11/i.test(desc)) {
        return isSubsequent(desc) ? 1 : 2;
    }

    // Committee / Agenda / Convener / AC Meeting
    if (/committee|agenda|convener|ac.?process|accreditation.*meeting|meeting.*accreditation/i.test(desc)) return 1;

    // Final Decision / Communication Letter / Decision Letter
    if (/final.?decision|decision.?letter|communication.?letter|marking.*decision/i.test(desc)) return 1;

    // Certificate Preparation — with advisory = 2, without = 1
    if (/certif/i.test(desc)) {
        return /advisory/i.test(desc) ? 2 : 1;
    }

    // Advisory (sent / replied / pending)
    if (/advisory/i.test(desc)) return 2;

    // Onsite / Midcycle / Witness
    if (/onsite|mid.?cycle|witness/i.test(desc)) {
        if (isSubsequent(desc)) return 1;
        return /no.?change/i.test(desc) ? 0 : 1;
    }

    // Document Review / Scrutiny / Awaiting CAB reply (scrutiny stage)
    if (/document.?review|document.?adequacy|awaiting.*reply.*cab|cab.*findings|nabl.*findings/i.test(desc)) {
        if (isSubsequent(desc)) return 1;
        if (/additional/i.test(name)) return 2;
        return 3;
    }

    // Subsequent iteration of any stage = 1 day
    if (isSubsequent(desc)) return 1;

    // Additional Applications scrutiny = 2 days
    if (/additional/i.test(name) || /additional/i.test(desc)) return 2;

    // Default: First Accreditation / Renewal scrutiny = 3 days
    return 3;
};

// Returns violation threshold (days) for a given role
// Prefers AllowedDays from API response; falls back to static calculation
export const getThreshold = (row, role) => {
    if (row && row.AllowedDays != null) return row.AllowedDays;
    return getDODays(row) + ESCALATION[role];
};

// Returns status string for a row given role
export const getTATStatus = (days, row, role) => {
    if (row && row.IsResolved) return 'resolved';
    if (days === null) return null;
    const threshold = getThreshold(row, role);
    if (days > threshold + 2) return 'violated';
    if (days >= threshold)    return 'violating';
    if (days >= threshold - 1) return 'warning';
    return 'ok';
};

export const daysFromStageDate = (stageDate) => {
    if (!stageDate) return null;
    const diff = Math.floor((Date.now() - new Date(stageDate)) / 86400000);
    return diff >= 0 ? diff : 0;
};
